import throttle from 'lodash/throttle'
import { useCallback, useEffect, useState } from 'react'

const useWidth = (throttleTime = 0) => {
  const [width, setWidth] = useState(window.innerWidth)

  const onResize = useCallback(
    throttle(() => {
      setWidth(window.innerWidth)
    }, throttleTime),
    []
  )

  useEffect(() => {
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return width
}

export default useWidth
